module.exports = __webpack_public_path__ + "static/media/1.a050aa61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16012/1.jpg
// module id = 505
// module chunks = 0